/** Canali di consegna Notifier (speculare a NotificationChannel backend). */
export enum NotificationChannel {
  Email = 0,
  Telegram = 1,
  Sms = 2,
  Teams = 3,
  SignalR = 4,
  WhatsApp = 5,
  MobilePush = 6,
}

/** Sottoscrizione notifiche dell'utente (GET /notifier/v1/subscriptions). */
export interface SubscriptionDto {
  id: number;
  partyId: string;
  partyContactId: string;
  dataOwnerId: string;
  appId: string;
  channel: NotificationChannel;
  additionalInfos?: string | null;
  active: boolean;
  /** Endpoint reale del contatto (RealEndPoint dal CRM), risolto dalla GET lista. */
  endPoint?: string | null;
  /** Nome leggibile dell'app (FunctionName con fallback a Name dal Workspace), risolto best-effort dalla GET lista. */
  appName?: string | null;
}

/** Contatto utilizzabile per un canale (GET /notifier/v1/subscriptions/contacts?channel=). */
export interface ChannelContact {
  partyContactId: string;
  endPoint?: string | null;
  name?: string | null;
  isDefault: boolean;
}

/** Patch di aggiornamento (PATCH /notifier/v1/subscriptions/{id}). */
export interface SubscriptionPatch {
  active?: boolean;
  partyContactId?: string;
}
